import { render } from "./App.vue?vue&type=template&id=2c59d75e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2c59d75e&lang=css"

import exportComponent from "/home/mateo/Documents/education/vue/fh-course/questions-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__